import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import About from "@/components/site/About";
import Services from "@/components/site/Services";
import Industries from "@/components/site/Industries";
import CaseStudies from "@/components/site/CaseStudies";
import Clients from "@/components/site/Clients";
import Careers from "@/components/site/Careers";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

const HomePage = () => (
  <div data-testid="home-page" className="App bg-[#FAF6EE] text-[#0A0A0A]">
    <Header />
    <main>
      <Hero />
      <About />
      <Services />
      <Industries />
      <CaseStudies />
      <Clients />
      <Careers />
      <Contact />
    </main>
    <Footer />
  </div>
);

function App() {
  return (
    <BrowserRouter>
      <Toaster
        position="bottom-right"
        richColors
        toastOptions={{
          style: {
            borderRadius: 0,
            border: "1px solid rgba(10,10,10,0.15)",
            fontFamily: "'IBM Plex Sans', sans-serif",
          },
        }}
      />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="*" element={<HomePage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
